// extracted by css-extract-rspack-plugin
export default {"checkedIcon":"ReportPicker_checkedIcon__XTExm","description":"ReportPicker_description__WWqhL"};